import { apiSlice } from './apiSlice'
import type { LookupItem } from './saleContractApi'

export interface SalePTBFFixation {
  id?: number | null
  ptbfFixationId?: number | null
  contractNo: string
  contractSale?: string | null
  buyersRef?: string | null
  cpCode?: string | null
  shortName?: string | null
  name?: string | null
  quality?: string | null
  description?: string | null
  quantity?: number | null
  mtons?: number | null
  noOfLots?: number | null
  ptbfDiffs?: number | null
  futuresMonth?: string | null
  balanceLotsTbf?: number | null
  finalPrice?: number | null
  dateFix?: string | null
  releaseDate?: string | null
  lotsFixed?: number | null
  levelFixed?: number | null
  fxRoe?: number | null
  uploadText?: string | null
  customerSignedText?: string | null
  unitTextVn?: string | null
  unitTextEn?: string | null
  finalPriceVnd?: number | null
  finalPriceUsd?: number | null
  qualityDescription?: string | null
  qualityDescriptionOffshore?: string | null
  qualityDescriptionContract?: string | null
  dateUpdate?: string | null
  personUpdate?: string | null
  createdDate?: string | null
  createdBy?: string | null
  updatedDate?: string | null
  updatedBy?: string | null
  isStatus?: number | null
  isUpload?: number | null
  isCusSign?: number | null
  fix1Date?: string | null
  fix1LotsFixed?: number | null
  fix1LevelFixed?: number | null
  fix2Date?: string | null
  fix2LotsFixed?: number | null
  fix2LevelFixed?: number | null
  fix3Date?: string | null
  fix3LotsFixed?: number | null
  fix3LevelFixed?: number | null
  fix4Date?: string | null
  fix4LotsFixed?: number | null
  fix4LevelFixed?: number | null
  fix5Date?: string | null
  fix5LotsFixed?: number | null
  fix5LevelFixed?: number | null
  fix6Date?: string | null
  fix6LotsFixed?: number | null
  fix6LevelFixed?: number | null
  fix7Date?: string | null
  fix7LotsFixed?: number | null
  fix7LevelFixed?: number | null
  fix8Date?: string | null
  fix8LotsFixed?: number | null
  fix8LevelFixed?: number | null
  fix9Date?: string | null
  fix9LotsFixed?: number | null
  fix9LevelFixed?: number | null
  fix10Date?: string | null
  fix10LotsFixed?: number | null
  fix10LevelFixed?: number | null
  fix11Date?: string | null
  fix11LotsFixed?: number | null
  fix11LevelFixed?: number | null
  fix12Date?: string | null
  fix12LotsFixed?: number | null
  fix12LevelFixed?: number | null
  fix13Date?: string | null
  fix13LotsFixed?: number | null
  fix13LevelFixed?: number | null
  fix14Date?: string | null
  fix14LotsFixed?: number | null
  fix14LevelFixed?: number | null
  fix15Date?: string | null
  fix15LotsFixed?: number | null
  fix15LevelFixed?: number | null
  fix16Date?: string | null
  fix16LotsFixed?: number | null
  fix16LevelFixed?: number | null
  fix17Date?: string | null
  fix17LotsFixed?: number | null
  fix17LevelFixed?: number | null
  fix18Date?: string | null
  fix18LotsFixed?: number | null
  fix18LevelFixed?: number | null
  fix19Date?: string | null
  fix19LotsFixed?: number | null
  fix19LevelFixed?: number | null
  fix20Date?: string | null
  fix20LotsFixed?: number | null
  fix20LevelFixed?: number | null
  fix21Date?: string | null
  fix21LotsFixed?: number | null
  fix21LevelFixed?: number | null
  fix22Date?: string | null
  fix22LotsFixed?: number | null
  fix22LevelFixed?: number | null
  fix23Date?: string | null
  fix23LotsFixed?: number | null
  fix23LevelFixed?: number | null
  fix24Date?: string | null
  fix24LotsFixed?: number | null
  fix24LevelFixed?: number | null
  fix25Date?: string | null
  fix25LotsFixed?: number | null
  fix25LevelFixed?: number | null
  fix26Date?: string | null
  fix26LotsFixed?: number | null
  fix26LevelFixed?: number | null
  fix27Date?: string | null
  fix27LotsFixed?: number | null
  fix27LevelFixed?: number | null
  fix28Date?: string | null
  fix28LotsFixed?: number | null
  fix28LevelFixed?: number | null
  fix29Date?: string | null
  fix29LotsFixed?: number | null
  fix29LevelFixed?: number | null
  fix30Date?: string | null
  fix30LotsFixed?: number | null
  fix30LevelFixed?: number | null
}

export interface SalePTBFFixationListResponse {
  items: SalePTBFFixation[]
  total: number
  page: number
  pageSize: number
}

export interface SalePTBFFixationListQuery {
  page: number
  pageSize: number
  q?: string
}

export interface SalePTBFFixationContractOptionsResponse {
  items: LookupItem[]
  total: number
}

export interface SalePTBFFixationLotToFixResponse {
  contractNo: string
  lotToFix?: number | null
  balanceLotsTbf?: number | null
  totalLot?: number | null
}

export interface SalePTBFFixationPayload {
  contractNo: string
  dateFix?: string | null
  releaseDate?: string | null
  lotsFixed?: number | null
  levelFixed?: number | null
  description?: string | null
  fxRoe?: number | null
  isUpload?: number | null
  isCusSign?: number | null
  contractSale?: string | null
  buyersRef?: string | null
  cpCode?: string | null
  shortName?: string | null
  name?: string | null
  quality?: string | null
  quantity?: number | null
  mtons?: number | null
  noOfLots?: number | null
  ptbfDiffs?: number | null
  futuresMonth?: string | null
  balanceLotsTbf?: number | null
  finalPrice?: number | null
  unitTextVn?: string | null
  unitTextEn?: string | null
  finalPriceVnd?: number | null
  finalPriceUsd?: number | null
  qualityDescription?: string | null
  qualityDescriptionOffshore?: string | null
  qualityDescriptionContract?: string | null
}

export interface SalePTBFFixationRow {
  ptbfFixationId?: number | null
  contractNo?: string | null
  dateFix?: string | null
  lotsFixed?: number | null
  levelFixed?: number | null
  createdDate?: string | null
  createdBy?: string | null
  updatedDate?: string | null
  updatedBy?: string | null
}

export interface SalePTBFFixationRowUpdate {
  dateFix?: string | null
  lotsFixed?: number | null
  levelFixed?: number | null
}

export interface SalePTBFFixationRowListResponse {
  items: SalePTBFFixationRow[]
  total: number
}

export interface SalePTBFFixationPrintOptions {
  contractNo: string
  fxRoe?: number | null
  note?: string | null
  noteSource?: string | null
  language?: string | null
}

export interface SalePTBFFixationPrintRequest {
  fxRoe?: number | null
  note?: string | null
}

export interface SalePTBFFixationPrintResponse {
  title: string
  html: string
  message?: string
}

const salePTBFFixationsApi = apiSlice.enhanceEndpoints({ addTagTypes: ['SalePTBFFixation'] }).injectEndpoints({
  endpoints: (builder) => ({
    getSalePTBFFixations: builder.query<SalePTBFFixationListResponse, SalePTBFFixationListQuery>({
      query: ({ page, pageSize, q }) => ({
        url: '/sale-ptbf-fixations',
        params: {
          page,
          pageSize,
          ...(q ? { q } : {}),
        },
      }),
      providesTags: ['SalePTBFFixation'],
    }),

    getSalePTBFFixation: builder.query<SalePTBFFixation, string>({
      query: (contractNo) => `/sale-ptbf-fixations/${encodeURIComponent(contractNo)}/edit-options`,
      providesTags: (_r, _e, contractNo) => [{ type: 'SalePTBFFixation', id: contractNo }],
    }),

    getSalePTBFFixationContracts: builder.query<SalePTBFFixationContractOptionsResponse, string | void>({
      query: (q) => ({ url: '/sale-ptbf-fixations/contracts', params: q ? { q } : {} }),
    }),

    getSalePTBFFixationLotToFix: builder.query<SalePTBFFixationLotToFixResponse, string>({
      query: (contractNo) => `/sale-ptbf-fixations/contracts/${encodeURIComponent(contractNo)}/lot-to-fix`,
    }),

    createSalePTBFFixation: builder.mutation<SalePTBFFixation, SalePTBFFixationPayload>({
      query: (body) => ({ url: '/sale-ptbf-fixations', method: 'POST', body }),
      invalidatesTags: ['SalePTBFFixation'],
    }),

    updateSalePTBFFixationEditOptions: builder.mutation<SalePTBFFixation, { contractNo: string; body: SalePTBFFixationPayload }>({
      query: ({ contractNo, body }) => ({
        url: `/sale-ptbf-fixations/${encodeURIComponent(contractNo)}/edit-options`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['SalePTBFFixation'],
    }),

    cancelSalePTBFFixation: builder.mutation<SalePTBFFixation, number>({
      query: (ptbfFixationId) => ({
        url: `/sale-ptbf-fixations/${ptbfFixationId}/cancel`,
        method: 'POST',
      }),
      invalidatesTags: ['SalePTBFFixation'],
    }),

    getSalePTBFFixationRows: builder.query<SalePTBFFixationRowListResponse, string>({
      query: (contractNo) => `/sale-ptbf-fixations/${encodeURIComponent(contractNo)}/rows`,
      providesTags: (_r, _e, contractNo) => [{ type: 'SalePTBFFixation', id: `rows:${contractNo}` }],
    }),

    updateSalePTBFFixationRow: builder.mutation<SalePTBFFixationRow, { ptbfFixationId: number; body: SalePTBFFixationRowUpdate }>({
      query: ({ ptbfFixationId, body }) => ({
        url: `/sale-ptbf-fixations/rows/${ptbfFixationId}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['SalePTBFFixation'],
    }),

    cancelSalePTBFFixationByContract: builder.mutation<{ deleted: number }, string>({
      query: (contractNo) => ({
        url: `/sale-ptbf-fixations/${encodeURIComponent(contractNo)}/cancel-fixations`,
        method: 'POST',
      }),
      invalidatesTags: ['SalePTBFFixation'],
    }),

    getSalePTBFFixationPrintEnOptions: builder.query<SalePTBFFixationPrintOptions, string>({
      query: (contractNo) => `/sale-ptbf-fixations/${encodeURIComponent(contractNo)}/print/en/options`,
    }),

    getSalePTBFFixationPrintVnOptions: builder.query<SalePTBFFixationPrintOptions, string>({
      query: (contractNo) => `/sale-ptbf-fixations/${encodeURIComponent(contractNo)}/print/vn/options`,
    }),

    printSalePTBFFixationEn: builder.mutation<SalePTBFFixationPrintResponse, { contractNo: string; body?: SalePTBFFixationPrintRequest }>({
      query: ({ contractNo, body }) => ({
        url: `/sale-ptbf-fixations/${encodeURIComponent(contractNo)}/print/en`,
        method: 'POST',
        body: body ?? {},
      }),
    }),

    printSalePTBFFixationVn: builder.mutation<SalePTBFFixationPrintResponse, { contractNo: string; body?: SalePTBFFixationPrintRequest }>({
      query: ({ contractNo, body }) => ({
        url: `/sale-ptbf-fixations/${encodeURIComponent(contractNo)}/print/vn`,
        method: 'POST',
        body: body ?? {},
      }),
    }),
  }),
})

export const {
  useGetSalePTBFFixationsQuery,
  useGetSalePTBFFixationQuery,
  useLazyGetSalePTBFFixationContractsQuery,
  useGetSalePTBFFixationLotToFixQuery,
  useCreateSalePTBFFixationMutation,
  useUpdateSalePTBFFixationEditOptionsMutation,
  useCancelSalePTBFFixationMutation,
  useGetSalePTBFFixationRowsQuery,
  useUpdateSalePTBFFixationRowMutation,
  useCancelSalePTBFFixationByContractMutation,
  useGetSalePTBFFixationPrintEnOptionsQuery,
  useGetSalePTBFFixationPrintVnOptionsQuery,
  usePrintSalePTBFFixationEnMutation,
  usePrintSalePTBFFixationVnMutation,
} = salePTBFFixationsApi

export default salePTBFFixationsApi
